import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../utils/api';

export default function FornecedoresImportExport() {
  const { token } = useAuth();
  const [arquivo, setArquivo] = useState(null);
  const [importando, setImportando] = useState(false);
  const [resultado, setResultado] = useState(null);

  const baixarTemplate = () => {
    const header = ['empresa','pais','cidade','estado','tipo','status','segmento','principais_produtos','atacado_real','aceita_oem','aceita_private_label','email','telefone','site','wechat','observacoes','fonte'];
    const exemplo = ['KYNKO Power Tools','China','Quanzhou','Fujian','Fabricante','aprovado','Ferramentas','Ferramentas elétricas profissionais','Sim','Não','Não','sales@kynko.com','+86 595 0000 0000','www.kynko.com','kynko_official','Excelente qualidade','Canton Fair 2025'];
    const csv = [header, exemplo].map(r => r.map(c=>`"${c}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type:'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'template_fornecedores.csv'; a.click();
  };

  const importar = async () => {
    if (!arquivo) return alert('Selecione um arquivo');
    setImportando(true);
    setResultado(null);
    try {
      const text = await arquivo.text();
      const lines = text.split('\n').filter(l => l.trim());
      const headers = lines[0].split(',').map(h => h.replace(/"/g,'').trim());
      const registros = [];
      for (let i = 1; i < lines.length; i++) {
        const vals = lines[i].match(/(".*?"|[^,]+)(?=\s*,|\s*$)/g) || [];
        const obj = {};
        headers.forEach((h, idx) => {
          let v = (vals[idx] || '').replace(/"/g,'').trim();
          if (['atacado_real','aceita_oem','aceita_private_label'].includes(h)) {
            obj[h] = v.toLowerCase() === 'sim' || v === '1' || v.toLowerCase() === 'true';
          } else {
            obj[h] = v || null;
          }
        });
        if (obj.empresa) registros.push(obj);
      }
      let ok = 0, erros = 0;
      for (const r of registros) {
        try { await api.post('/fornecedores', r, token); ok++; }
        catch(e) { erros++; }
      }
      setResultado({ ok, erros, total: registros.length });
    } catch(e) {
      setResultado({ erro: 'Erro ao processar arquivo. Verifique o formato.' });
    }
    setImportando(false);
    setArquivo(null);
  };

  const exportar = async () => {
    try {
      const data = await api.get('/fornecedores', token);
      const header = ['empresa','pais','cidade','estado','tipo','status','segmento','principais_produtos','atacado_real','aceita_oem','aceita_private_label','email','telefone','site','wechat','observacoes','fonte'];
      const rows = [header, ...data.map(f => header.map(h => {
        const v = f[h];
        if (typeof v === 'boolean') return v ? 'Sim' : 'Não';
        return v || '';
      }))];
      const csv = rows.map(r => r.map(c=>`"${String(c).replace(/"/g,'""')}"`).join(',')).join('\n');
      const blob = new Blob(['\uFEFF'+csv], { type:'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `fornecedores_${new Date().toISOString().slice(0,10)}.csv`; a.click();
    } catch(e) { alert('Erro ao exportar'); }
  };

  return (
    <div style={{padding:32,maxWidth:700,margin:'0 auto'}}>
      <h1 style={{fontSize:20,fontWeight:700,color:'#0B0E1A',margin:'0 0 6px'}}>Importar / Exportar</h1>
      <p style={{fontSize:13,color:'#9095A8',margin:'0 0 32px'}}>Carga em massa via CSV.</p>

      {/* Importar */}
      <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)',marginBottom:20}}>
        <div style={{fontSize:14,fontWeight:700,color:'#0B0E1A',marginBottom:6}}>Importar planilha</div>
        <div style={{fontSize:13,color:'#6B7289',marginBottom:20}}>Aceita .csv. As colunas devem corresponder ao template.</div>

        <div style={{display:'flex',gap:12,alignItems:'center',marginBottom:16}}>
          <label style={{cursor:'pointer'}}>
            <div style={{background:'#F4F5F9',border:'1px dashed #C8CADC',borderRadius:8,padding:'12px 20px',fontSize:13,color:'#3D4461',display:'inline-block'}}>
              {arquivo ? arquivo.name : 'Selecionar arquivo (.csv)'}
            </div>
            <input type="file" accept=".csv" style={{display:'none'}} onChange={e => setArquivo(e.target.files[0])} />
          </label>
          <button onClick={baixarTemplate}
            style={{background:'#EEF1FF',color:'#1A2ECC',border:'none',borderRadius:8,padding:'10px 16px',fontSize:13,fontWeight:600,cursor:'pointer',whiteSpace:'nowrap'}}>
            Baixar template
          </button>
        </div>

        <button onClick={importar} disabled={importando || !arquivo}
          style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'10px 24px',fontSize:13,fontWeight:600,cursor:'pointer',opacity:(importando||!arquivo)?0.6:1}}>
          {importando ? 'Importando...' : 'Iniciar importação'}
        </button>

        {resultado && (
          <div style={{marginTop:16,padding:14,borderRadius:8,background:resultado.erro?'#FEE2E2':'#ECFDF5',color:resultado.erro?'#D63B3B':'#065F46',fontSize:13}}>
            {resultado.erro
              ? resultado.erro
              : `✓ ${resultado.ok} de ${resultado.total} registros importados com sucesso.${resultado.erros > 0 ? ` ${resultado.erros} com erro.` : ''}`
            }
          </div>
        )}
      </div>

      {/* Exportar */}
      <div style={{background:'#fff',borderRadius:12,padding:24,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
        <div style={{fontSize:14,fontWeight:700,color:'#0B0E1A',marginBottom:6}}>Exportar base completa</div>
        <div style={{fontSize:13,color:'#6B7289',marginBottom:20}}>Baixe toda a base de fornecedores em CSV.</div>
        <button onClick={exportar}
          style={{background:'#0FA36B',color:'#fff',border:'none',borderRadius:8,padding:'10px 24px',fontSize:13,fontWeight:600,cursor:'pointer'}}>
          Baixar CSV
        </button>
      </div>
    </div>
  );
}
